import {html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {IFilterable} from './interfaces/filterable';

@customElement('ri-filter-entry')
export class FilterEntry extends LitElement {
  @property({attribute: false}) filterable: IFilterable | undefined;
  override render() {
    return html`${this.filterable}`;
  }
}
